import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class SubstanceAliasTranslations extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition
    ) {
        super(new FormGroup({}), 
            [...fieldDefinition.substanceAliasTranslationsFields], {});
    }
}